import React from 'react';
const ReminderMessagesConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/admin-reminderMessage',
			component: React.lazy(() => import('../../company-profile/customerAccountDetails/SideNavigationPages/reminderMessage/ReminderMsg'))
		},
		
	]
};
export default ReminderMessagesConfig;
